import type React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Shown inside the authenticated shell when the route's guard finds the caller
 * lacks its action, so a typed URL never reveals data the user cannot read.
 */
const ForbiddenPage: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'page.forbidden' })

  return (
    <main className="flex flex-1 flex-col items-center justify-center gap-4 p-6">
      <h1 className="text-4xl font-semibold">{t('code')}</h1>
      <p className="text-muted-foreground">{t('title')}</p>
      <Link to="/pulse" className="text-sm underline underline-offset-4">
        {t('backToDashboard')}
      </Link>
    </main>
  )
}

export default ForbiddenPage
